/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import PropTypes from 'prop-types';
import React__default from 'react';
import cx from 'classnames';
import '../ListBox/index.js';
import { usePrefix } from '../../internal/usePrefix.js';
import { ListBoxSize } from '../ListBox/ListBoxPropTypes.js';

const DropdownSkeleton = _ref => {
  let {
    className,
    size,
    hideLabel,
    ...rest
  } = _ref;
  const prefix = usePrefix();
  const wrapperClasses = cx(className, `${prefix}--skeleton`, `${prefix}--form-item`, {
    [`${prefix}--list-box--${size}`]: size
  });
  return /*#__PURE__*/React__default.createElement("div", _extends({
    className: wrapperClasses
  }, rest), !hideLabel && /*#__PURE__*/React__default.createElement("span", {
    className: `${prefix}--label ${prefix}--skeleton`
  }), /*#__PURE__*/React__default.createElement("div", {
    className: `${prefix}--skeleton ${prefix}--dropdown`
  }));
};
DropdownSkeleton.propTypes = {
  /**
   * Specify an optional className to add.
   */
  className: PropTypes.string,
  /**
   * Specify whether the label should be hidden, or not
   */
  hideLabel: PropTypes.bool,
  /**
   * Specify the size of the ListBox.
   */
  size: ListBoxSize
};

export { DropdownSkeleton, DropdownSkeleton as default };
